import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../features/auth/AuthContext';

// Sous-ensemble de AdminRoute réservé au rôle ADMIN strict (pas ASSISTANT) :
// gestion des comptes admin/assistant et journal d'activité.
export function AdminOnlyRoute() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== 'ADMIN') {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
}
